/**
 * 金额小数规整(1006 演示机复测:招投标卡「预算金额95.000000万元」)。
 *
 * 来源:卡上的事实句 / 推断句是 ai 从公告原文摘出的字符串(公告里就写着 95.000000 万元),
 * api/ai 原样透传 —— 不是 console 拼的数。只在显示层规整:金额(后接「元 / 万元 / 亿元」)
 * 小数超过 2 位的,去掉末尾 0(全是 0 连小数点一起去);2 位以内(2,163,800.00 元)和
 * 有效小数(134.058 万元)不动。
 */
export function tidyMoneyDecimals(text: string | null | undefined): string {
  if (!text) return text ?? "";
  return text.replace(/(\d)\.(\d{3,})(?=\s*(?:万|亿)?元)/g, (_m, lead: string, dec: string) => {
    const kept = dec.replace(/0+$/, "");
    return kept ? `${lead}.${kept}` : lead;
  });
}
